<template>
  <div class="faq-item" :class="{ expanded: is_expanded }">
    <b-link
      :id="`toggle-${content.id}`"
      class="h5 faq-toggle"
      v-b-toggle="`collapse-${content.id}`"
    >
      {{ content.question }}
    </b-link>
    <b-collapse
      :id="`collapse-${content.id}`"
      v-model="is_expanded"
      class="faq-body"
    >
      <b-container class="mx-3 pb-3 pl-4" v-html="content.answer"></b-container>
    </b-collapse>
  </div>
</template>

<script setup>
import { defineProps, ref } from "vue";

const { content } = defineProps({
  content: {
    type: Object,
    required: true,
  },
});
const is_expanded = ref(false);
</script>

<style scoped>
.faq-item {
  background: white;
  transition: background 0.1s ease;
}
.faq-item.expanded {
  background: #f2f2f2;
}
.faq-toggle {
  position: relative;
  padding: 1rem 1rem 1rem 3rem;
  display: block;
  color: black;
  background: white;
}
.faq-toggle:hover,
.faq-toggle:not(.collapsed) {
  text-decoration: underline;
}
.faq-toggle:not(.collapsed) {
  background: #f2f2f2;
  font-weight: 700;
}
.faq-toggle::before {
  content: "►";
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
}
.faq-toggle:not(.collapsed)::before {
  content: "▼";
}
.faq-body {
  background: #f2f2f2;
}
</style>
